import React, { Component } from 'react';
import { Input, Button, Table } from 'antd';
import styled from 'styled-components';
const { Search } = Input;
const Container = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
  }
`;

export default class ReservationSetting extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        storeName: '',
        pageNo: 1,
        pageSize: 10
      },

      storeList: [{ kdtId: 1 }],
      total: 0,
    };
  }

  toDetail = item => {
    this.props.history.push('/login')
  }

  render() {
    const { searchParams, storeList, total } = this.state;
    const columns = [
      {
        title: '有赞店铺名称',
        dataIndex: 'yzStoreName',
        key: 'yzStoreName'
      },
      {
        title: '有赞店铺ID',
        dataIndex: 'kdtId',
        key: 'kdtId'
      },
      {
        title: '营业时间',
        dataIndex: 'businessHours',
        key: 'businessHours'
      },
      {
        title: '分隔时长(分钟)',
        dataIndex: 'time',
        key: 'time'
      },
      {
        title: '操作',
        render: item => <Button type="link" onClick={() => this.toDetail(item)}>编辑</Button>
      }
    ];

    return (
      <Container>
      <div className="search-wrapper">
        <div className="search">
          <span className="label">店铺名称：</span>
          <Search
              allowClear
              enterButton="搜索"
              value={searchParams.storeName}
              placeholder="请输入店铺名称/ID"
              className="search-input"
              onSearch={this.onSearch}
              onChange={e => {
                const value = e.target.value;
                this.setState({ searchParams: Object.assign(searchParams, { storeName: value }) });
              }}
          />
        </div>
      </div>

      <div className="content-wrapper">
        <Table
          rowKey="kdtId"
          columns={columns}
          dataSource={storeList}
          pagination={{
            current: searchParams.pageNo,
            pageSize: searchParams.pageSize,
            total,
            showTotal: total => `共${total}条`,
            hideOnSinglePage: false,
            onChange: this.onPageChange
          }}
        />
      </div>
    </Container>
    );
  }
 }
